import React from 'react';
import { Path, Svg } from 'react-native-svg';

interface CheckIconProps {
  size?: number;
  color?: string;
}

export const CheckIcon: React.FC<CheckIconProps> = ({
  size = 14,
  color = '#1A1A1A'
}) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 14 11" fill="none">
      <Path
        d="M13 1L4.75 9.25L1 5.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
};